
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorDeInicio } from '../controlador';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        //public get Controlador() { return new ControladorDeInicio(); }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {


        }


    }
